<template>
  <div class="dialog_container">
    <el-dialog
      title="编辑车辆维修记录"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="form"
          class="add_staff_form"
          :model="redactForm"
          label-width="130px"
        >
          <el-form-item label="车牌号码：">
            <el-input v-model="redactForm.carNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色：">
            <el-input v-model="redactForm.carColorStr" disabled></el-input>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-input v-model="redactForm.repairTypeStr" disabled></el-input>
          </el-form-item>
          <el-form-item label="厂牌型号：">
            <el-input v-model="redactForm.carModel" disabled> </el-input>
          </el-form-item>
          <el-form-item label="车辆营运性质：">
            <el-input v-model="redactForm.carServiceStr" disabled> </el-input>
          </el-form-item>
          <el-form-item label="车主单位：">
            <el-input v-model="redactForm.companyUserName" disabled> </el-input>
          </el-form-item>
          <el-form-item label="维修状态：">
            <el-input v-model="redactForm.stateStr" disabled> </el-input>
          </el-form-item>
        </el-form>

        <div class="form_title">维修信息</div>
        <el-form
          ref="redactForm"
          class="add_staff_form"
          :model="redactForm"
          label-width="130px"
        >
          <el-form-item label="维修企业：">
            <el-input
              v-model="redactForm.repairCompanyName"
              placeholder="请输入维修企业"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="进厂时间：">
            <el-date-picker
              type="datetime"
              placeholder="选择进厂时间"
              v-model="redactForm.factoryTimeStr"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="进厂里程数：">
            <el-input
              v-model="redactForm.factoryMile"
              placeholder="请输入进厂里程数"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="提交送检时间：">
            <el-date-picker
              type="datetime"
              placeholder="选择提交送检时间"
              v-model="redactForm.inspectTimeStr"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工位：">
            <el-input
              v-model="redactForm.station"
              placeholder="请输入工位"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="主修人员：">
            <el-input
              v-model="redactForm.repairPerson"
              placeholder="请输入主修人员"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="维修开始时间：">
            <el-date-picker
              type="datetime"
              placeholder="选择维修开始时间"
              v-model="redactForm.inspectStartTimeStr"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="维修结束时间：">
            <el-date-picker
              type="datetime"
              placeholder="选择维修结束时间"
              v-model="redactForm.inspectEndTimeStr"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="技术负责人：">
            <el-input
              v-model="redactForm.technologyPerson"
              placeholder="请输入技术负责人"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="辅修人员：">
            <el-input
              v-model="redactForm.minorPerson"
              placeholder="请输入辅修人员"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="下次维修时间：">
            <el-date-picker
              type="datetime"
              placeholder="选择下次维修时间"
              v-model="redactForm.nextRepairTimeStr"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="下次维修里程：">
            <el-input
              v-model="redactForm.nextRepairMile"
              placeholder="请输入下次维修里程"
            ></el-input>
          </el-form-item>
          <el-form-item label="质检员：">
            <el-input
              v-model="redactForm.qualityPerson"
              placeholder="请输入质检员"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="form_title">图片及附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">进厂图片</div>
              <div v-if="redactForm.factoryImage" class="onebox">
                <div
                  class="twobox"
                  v-if="redactForm.factoryImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + redactForm.factoryImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    redactForm.factoryImage &&
                    redactForm.factoryImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + redactForm.factoryImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!redactForm.factoryImage ? true : false"
                  @click="handlePictureCardPreview(1)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !redactForm.factoryImage ||
                    redactForm.factoryImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(1)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>

          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">送检图片</div>
              <div v-if="redactForm.inspectImage" class="onebox">
                <div
                  class="twobox"
                  v-if="redactForm.inspectImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + redactForm.inspectImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    redactForm.inspectImage &&
                    redactForm.inspectImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + redactForm.inspectImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!redactForm.inspectImage ? true : false"
                  @click="handlePictureCardPreview(2)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !redactForm.inspectImage ||
                    redactForm.inspectImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(2)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">维修结束图片</div>
              <div v-if="redactForm.repairImage3" class="onebox">
                <div
                  class="twobox"
                  v-if="redactForm.repairImage3.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + redactForm.repairImage3"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <div class="img_btns" @click="getImgIndex(1)">
                  <el-upload
                    class="avatar-uploader_btn"
                    action="http://47.101.220.89:8687/file/uploadFile"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                    :http-request="uploadFile"
                  >
                    <el-button class="img_btn">{{
                      redactForm.repairImage3 ? "变更" : "上传"
                    }}</el-button>
                  </el-upload>
                </div>
                <el-button
                  class="img_btn"
                  v-if="
                    redactForm.repairImage3 &&
                    redactForm.repairImage3.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + redactForm.repairImage3"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!redactForm.repairImage3 ? true : false"
                  @click="handlePictureCardPreview(3)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !redactForm.repairImage3 ||
                    redactForm.repairImage3.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(3)"
                  >下载</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="!redactForm.repairImage3 ? true : false"
                  @click="handleRemove(3)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">
                <img
                  src="../../../../static/images/xinghao_icon.png"
                  alt=""
                />结算清单
              </div>
              <div v-if="redactForm.repairCost" class="onebox">
                <div
                  class="twobox"
                  v-if="redactForm.repairCost.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + redactForm.repairCost"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <div class="img_btns" @click="getImgIndex(2)">
                  <el-upload
                    class="avatar-uploader_btn"
                    action="http://47.101.220.89:8687/file/uploadFile"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                    :http-request="uploadFile"
                  >
                    <el-button class="img_btn">{{
                      redactForm.repairCost ? "变更" : "上传"
                    }}</el-button>
                  </el-upload>
                </div>
                <el-button
                  class="img_btn"
                  v-if="
                    redactForm.repairCost &&
                    redactForm.repairCost.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + redactForm.repairCost"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!redactForm.repairCost ? true : false"
                  @click="handlePictureCardPreview(4)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !redactForm.repairCost ||
                    redactForm.repairCost.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(4)"
                  >下载</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="!redactForm.repairCost ? true : false"
                  @click="handleRemove(4)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">
                <img
                  src="../../../../static/images/xinghao_icon.png"
                  alt=""
                />合格证
              </div>
              <div v-if="redactForm.repairCertImage" class="onebox">
                <div
                  class="twobox"
                  v-if="redactForm.repairCertImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + redactForm.repairCertImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <div class="img_btns" @click="getImgIndex(3)">
                  <el-upload
                    class="avatar-uploader_btn"
                    action="http://47.101.220.89:8687/file/uploadFile"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                    :http-request="uploadFile"
                  >
                    <el-button class="img_btn">{{
                      redactForm.repairCertImage ? "变更" : "上传"
                    }}</el-button>
                  </el-upload>
                </div>
                <el-button
                  class="img_btn"
                  v-if="
                    redactForm.repairCertImage &&
                    redactForm.repairCertImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + redactForm.repairCertImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!redactForm.repairCertImage ? true : false"
                  @click="handlePictureCardPreview(5)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !redactForm.repairCertImage ||
                    redactForm.repairCertImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(5)"
                  >下载</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="!redactForm.repairCertImage ? true : false"
                  @click="handleRemove(5)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :url="dialogImageUrl"
    />
  </div>
</template>

<script>
import { dateTransition, timestampToTime,downloadFile } from "@/utils/util";
import config from "@/utils/config";
import previewImage from "@/components/previewImage.vue";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      redactForm: {},
      receiveList: [],
      headers: {},
      imgIndex: 1,
      imgHttp: "",
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false
    };
  },
  components: {
    previewImage
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: Object,
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.headers = {
          Authorization: sessionStorage.getItem("Token"),
          "Content-Type": "multipart/form-data",
        };
        this.imgHttp = config.baseUrl;
        this.redactForm = {
          id: this.dialogData.repairId,
          factoryImage: this.dialogData.factoryImage,
          inspectImage: this.dialogData.inspectImage,
          carColorStr: this.dialogData.carColorStr,
          carNumber: this.dialogData.carNumber,
          repairTypeStr: this.dialogData.repairTypeStr,
          carServiceStr: this.dialogData.carServiceStr,
          stateStr: "送检中",
          carModel: this.dialogData.carModel,
          companyUserName: this.dialogData.companyUserName,
          repairCompanyName: this.dialogData.repairCompanyName,
          factoryTimeStr: this.dialogData.factoryTime
            ? new Date(this.dialogData.factoryTime)
            : "",
          factoryMile: this.dialogData.factoryMile,
          inspectTimeStr: this.dialogData.inspectTime
            ? new Date(this.dialogData.inspectTime)
            : "",
          station: this.dialogData.station,
          repairPerson: this.dialogData.repairPerson,
          inspectStartTimeStr: this.dialogData.inspectStartTime
            ? new Date(this.dialogData.inspectStartTime)
            : "",
          technologyPerson: this.dialogData.technologyPerson,
          minorPerson: this.dialogData.minorPerson,
        };
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      if (!this.redactForm.repairCost || !this.redactForm.repairCertImage) {
        this.$message.info("请将 结算清单/合格证 图片上传完整！");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.redactForm.factoryTimeStr = timestampToTime(
          this.redactForm.factoryTimeStr
        );
        this.redactForm.inspectTimeStr = timestampToTime(
          this.redactForm.inspectTimeStr
        );
        this.redactForm.inspectStartTimeStr = timestampToTime(
          this.redactForm.inspectStartTimeStr
        );
        this.redactForm.nextRepairTimeStr = timestampToTime(
          this.redactForm.nextRepairTimeStr
        );
        this.redactForm.inspectEndTimeStr = timestampToTime(
          this.redactForm.inspectEndTimeStr
        );
        this.$http.updateRepair2(this.redactForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.addForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    getImgIndex(index) {
      this.imgIndex = index;
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        if (this.imgIndex === 1) {
          this.redactForm.repairImage3 = res.msg;
        } else if (this.imgIndex === 2) {
          this.redactForm.repairCost = res.msg;
        } else if (this.imgIndex === 3) {
          this.redactForm.repairCertImage = res.msg;
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf";
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pdf且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
    handlePictureCardPreview(index) {
      let url = "";
      let name = "";
      if (index === 1) {
        url = this.redactForm.factoryImage;
        name = "进厂图片";
      } else if (index === 2) {
        url = this.redactForm.inspectImage;
        name = "送检图片";
      } else if (index === 3) {
        url = this.redactForm.repairImage3;
        name = "维修结束图片";
      } else if (index === 4) {
        url = this.redactForm.repairCost;
        name = "结算清单";
      } else if (index === 5) {
        url = this.redactForm.repairCertImage;
        name = "合格证";
      }
      this.dialogImageUrl = this.imgHttp + url;
      this.dialogImageName = name;
      this.dialogVisible = true;
    },
    downs(index) {
      let url = "";
      let name = "";
      if (index === 1) {
        url = this.redactForm.factoryImage;
        name = "进厂图片";
      } else if (index === 2) {
        url = this.redactForm.inspectImage;
        name = "送检图片";
      } else if (index === 3) {
        url = this.redactForm.repairImage3;
        name = "维修结束图片";
      } else if (index === 4) {
        url = this.redactForm.repairCost;
        name = "结算清单";
      } else if (index === 5) {
        url = this.redactForm.repairCertImage;
        name = "合格证";
      }
      downloadFile(this.imgHttp + url, name);
    },
    handleRemove(index) {
      if (index === 3) {
        this.redactForm.repairImage3 = "";
      } else if (index === 4) {
        this.redactForm.repairCost = "";
      } else if (index === 5) {
        this.redactForm.repairCertImage = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .certificate {
    width: 360px;
    height: 270px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    display: flex;
    justify-content: center;
    align-items: center;

    .image_con {
      width: 100%;
      height: 100%;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader {
      width: 100%;
      height: 100%;
      border-radius: 2px;
      border: 1px solid #d1d1d1;
      display: flex;
      justify-content: center;
      align-items: center;

      .uploading_icon {
        width: 91px;
        height: 70px;
        margin-top: 15px;
      }

      .img_box {
        width: 238px;
        height: 157px;
        .avatar {
          width: 100%;
          height: 100%;
          margin-top: 0;
        }
      }
    }
    .card_title {
      width: 100%;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 6px;
        height: 6px;
      }
    }
  }
  .certificate:nth-child(n + 3) {
    margin-top: 30px;
  }
}
/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/redact_2.vue